import SiteBreadCrumb from "../../components/page-breadcrumb/page-breadcrumb.component";
import Typography from "@mui/material/Typography";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {MessageTypesEnum} from "../../enums/message-types.enum";
import ActionButton from "../../components/button/button.component";
import TextInputField from "../../components/input/text-input-field.component";
import {NewsletterModel} from "../../models/newsletter.model";
import {getNewsLetterEmail, setNewsLetterEmail} from "../../store/reducers/newsletter/newsletter.reducer";
import {getCurrentUser} from "../../store/reducers/user/user.reducer";
import toast from "react-hot-toast";
import sendApiRequest, {NetworkMethods} from "../../lib/Network";
import {ApiResponseModel} from "../../models/apiresponse.model";
import AdvancedTable from "../../components/tables/advanced_table.component";
import DeleteDialog from "../../components/dialog/delete-dialog.component";

export default function NewsletterPage() {
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [entries, setEntries] = useState<NewsletterModel[]>([]);
    const [open, setOpen] = useState<boolean>(false);
    const [deletingId, setDeletingId] = useState<string>("");

    const email = useSelector(getNewsLetterEmail);
    const currentUser = useSelector(getCurrentUser);

    const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => dispatch(setNewsLetterEmail(e.target.value));

    useEffect(() => {
        getNewsLetter();

        return () => {};
    }, []);

    const getNewsLetter = async () => {
        try {
            setIsLoading(true);

            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.GET,
                endpoint: `newsletter`,
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a lekérdezés közben! Indok: ${response?.error ?? "Nincs indok!"}`)
                return
            }

            let apiResponse: ApiResponseModel = response.data;

            setEntries(apiResponse.data);
            setIsLoading(false);
        } catch (error: any) {
            toast.error(`Hiba a lekérdezés közben (${error?.message ?? "Nincs indok!"})!`);
        }
    }
    const removeNewsletter = async (identifier: string) => {
        try {
            setIsLoading(true);

            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.GET,
                endpoint: `newsletter/unsubscribe/${identifier}`,
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a végrehajtás közben! Indok: ${response?.error ?? "Nincs indok!"}`)
                return
            }

            await getNewsLetter();
        } catch (error: any) {
            toast.error(`Hiba a végrehajtás közben (${error?.message ?? "Nincs indok!"})!`);
        }
    }
    const onSubmit = async () => {
        try {
            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.POST,
                endpoint: `newsletter/subscribe`,
                payload: {
                    email
                }
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a feliratkozás közben! Indok: ${response?.error ?? "Nincs indok!"}`)
                return
            }

            setNewsLetterEmail("");
            await getNewsLetter();
        } catch (error: any) {
            toast.error(`Hiba a feliratkozás közben (${error?.message ?? "Nincs indok!"})!`);
        }
    }

    return (
      <div>
        <SiteBreadCrumb
          sites={[
            {
              name: "Főoldal",
              url: "/",
            },
            {
              name: "Hírlevél",
              url: "/hirlevel",
            },
          ]}
        />
        <Typography variant="h3">Hírlevél varázsló</Typography>
        <br />
        <TextInputField
          title={"E-mail cím"}
          value={email}
          onChange={onEmailChange}
        />
        <br />
        <ActionButton
          title={"Feliratkozás hozzáadása"}
          type="SAVE"
          action={onSubmit}
        />
        <br />
        <br />
        <Typography variant="h3">Hírlevél feliratkozások</Typography>
        <br />
        <AdvancedTable
          columns={["ID", "Azonosító", "E-mail"]}
          rows={entries.map((entry) => ({
            id: entry.id,
            identifier: entry.identifier,
            email: entry.email,
          }))}
          properties={{
            page: 1,
            pages: 1,
            rowsPerPage: 10,
            totalRows: 10,
            disableSee: true,
            disableEdit: true,
            disableDelete: false,
          }}
          rowActions={{
            deleteAction: (row: any) => {
              setDeletingId(row.identifier);
              setOpen(true);
            },
            editAction: () => {},
            seeAction: (row: any) => {},
          }}
          pageChange={() => {}}
        />
        <DeleteDialog
          isOpen={Boolean(deletingId)}
          closeAction={() => setDeletingId("")}
          action={() => {
            removeNewsletter(deletingId);
            setDeletingId("");
          }}
        />
      </div>
    );
}